import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo-gray.svg';
import _imports_1 from '@/assets/icon/icon-menu-default.svg';
import _imports_2 from '@/assets/icon/icon-x-default.svg';

const _withScopeId = n => (_pushScopeId("data-v-71f5ef98"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "nav-container"
};
const _hoisted_2 = {
  class: "wrapper"
};
const _hoisted_3 = ["onClick"];

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "investNFT"
}, null, -1));

const _hoisted_5 = {
  key: 0,
  class: "beta-wrapper"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-caption2 beta"
}, "Beta", -1));

const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  class: "content-container tablet-hidden"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("a", {
  class: "nav-item-wrapper cursor",
  href: `/#features`,
  style: {
    "text-decoration": "none"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "font-subtitle2"
}, "Features")])], -1));

const _hoisted_10 = ["onClick"];

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-subtitle2"
}, "Explore", -1));

const _hoisted_12 = [_hoisted_11];

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-subtitle2"
}, "Gitbook", -1));

const _hoisted_14 = [_hoisted_13];

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-subtitle2"
}, "FAQ", -1));

const _hoisted_16 = [_hoisted_15];
const _hoisted_17 = {
  class: "r-wrapper desktop-hidden-tablet"
};
const _hoisted_18 = {
  key: 0,
  class: "menu desktop-hidden-tablet"
};

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("a", {
  class: "nav-item-wrapper cursor first",
  href: `/#features`,
  style: {
    "text-decoration": "none",
    "height": "41px"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "font-subtitle1"
}, "Features")])], -1));

const _hoisted_20 = ["onClick"];

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-subtitle1"
}, "Explore", -1));

const _hoisted_22 = [_hoisted_21];

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-subtitle1"
}, "Gitbook", -1));

const _hoisted_24 = [_hoisted_23];

const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-subtitle1"
}, "FAQ", -1));

const _hoisted_26 = [_hoisted_25];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  const _component_list_selector = _resolveComponent("list-selector");

  const _component_user_selector = _resolveComponent("user-selector");

  const _component_connect_wallet_modal = _resolveComponent("connect-wallet-modal");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_router_link, {
    custom: "",
    to: {
      name: 'Landing'
    }
  }, {
    default: _withCtx(({
      navigate
    }) => [_createElementVNode("div", {
      class: "logo-container cursor",
      onClick: navigate
    }, [_hoisted_4, false ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)) : _createCommentVNode("", true)], 8, _hoisted_3)]),
    _: 1
  }), _createElementVNode("div", _hoisted_8, [_createVNode(_component_list_selector, {
    placeholder: "Alliance NFT",
    name: "alliance",
    list: $options.allianceList,
    onChange: $options.goRoute
  }, null, 8, ["list", "onChange"]), _hoisted_9, _createVNode(_component_router_link, {
    custom: "",
    to: {
      name: 'CollectionStore',
      params: {
        collection: '',
        chain: ''
      }
    }
  }, {
    default: _withCtx(({
      navigate
    }) => [_createElementVNode("div", {
      class: "nav-item-wrapper cursor",
      onClick: navigate
    }, _hoisted_12, 8, _hoisted_10)]),
    _: 1
  }), _createElementVNode("div", {
    class: "nav-item-wrapper cursor",
    onClick: _cache[0] || (_cache[0] = $event => $options.externalLink('https://investnft.gitbook.io/investnft/'))
  }, _hoisted_14), _createElementVNode("div", {
    class: "nav-item-wrapper cursor",
    onClick: _cache[1] || (_cache[1] = $event => $options.externalLink('https://investnft.gitbook.io/investnft/faq/first-alliance-faq'))
  }, _hoisted_16), $props.currentAccount ? (_openBlock(), _createBlock(_component_list_selector, {
    key: 0,
    name: "user",
    list: $options.chainList,
    value: $props.chainId,
    onChange: $options.changeNetwork
  }, null, 8, ["list", "value", "onChange"])) : _createCommentVNode("", true), _createVNode(_component_user_selector, {
    list: $options.userList,
    avatar: $data.avatar
  }, null, 8, ["list", "avatar"])]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_user_selector, {
    list: $options.userList,
    avatar: $data.avatar
  }, null, 8, ["list", "avatar"]), _createElementVNode("div", {
    class: "icon-rounded-wrapper toggle",
    onClick: _cache[2] || (_cache[2] = $event => $data.isToggle = !$data.isToggle)
  }, [_createElementVNode("img", {
    class: _normalizeClass(["type", {
      visible: !$data.isToggle
    }]),
    src: _imports_1,
    alt: "menu"
  }, null, 2), _createElementVNode("img", {
    class: _normalizeClass(["type", {
      visible: $data.isToggle
    }]),
    src: _imports_2,
    alt: "x"
  }, null, 2)])])]), $data.isToggle ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_list_selector, {
    placeholder: "Alliance NFT",
    name: "alliance",
    list: $options.allianceList,
    onChange: $options.goRoute
  }, null, 8, ["list", "onChange"]), _hoisted_19, _createVNode(_component_router_link, {
    custom: "",
    to: {
      name: 'CollectionStore',
      params: {
        collection: '',
        chain: ''
      }
    }
  }, {
    default: _withCtx(({
      route,
      navigate
    }) => [_createElementVNode("div", {
      class: "nav-item-wrapper cursor",
      onClick: $event => $options.mobileClick(route, navigate)
    }, _hoisted_22, 8, _hoisted_20)]),
    _: 1
  }), _createElementVNode("div", {
    class: "nav-item-wrapper cursor",
    onClick: _cache[3] || (_cache[3] = $event => $options.externalLink('https://investnft.gitbook.io/investnft/'))
  }, _hoisted_24), _createElementVNode("div", {
    class: "nav-item-wrapper cursor last",
    onClick: _cache[4] || (_cache[4] = $event => $options.externalLink('https://investnft.gitbook.io/investnft/faq/first-alliance-faq'))
  }, _hoisted_26)])) : _createCommentVNode("", true)]), $data.isConnectWalletModalDisplay ? (_openBlock(), _createBlock(_component_connect_wallet_modal, {
    key: 0
  })) : _createCommentVNode("", true)], 64);
}